import { apiClient } from '../../../shared/api/client.js';
import type { Book } from '../../../shared/types/index.js';

export const verificationApi = {
  async updateStatus(
    id: string,
    status: string,
    note?: string
  ): Promise<{ message: string; book: Book }> {
    return apiClient(`/api/verification/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status, note }),
    });
  },

  async triggerAutoApprove(): Promise<{ success: boolean; message: string }> {
    return apiClient('/api/verification/auto-approve', {
      method: 'POST',
    });
  },
};
